import {
  Grouping as SharedGrouping,
  GROUPING_TYPES as SharedGROUPING_TYPES,
  GROUPING_SCOPES as SharedGROUPING_SCOPES,
  GROUPING_STATUSES as SharedGROUPING_STATUSES,
  CRITERION_CATEGORIES as SharedCRITERION_CATEGORIES,
} from "shared/dist/types/Grouping";

export type {
  GroupingType,
  GroupingScope,
  GroupingStatus,
  CriterionCategory,
  Criterion,
} from "shared/dist/types/Grouping";

export { FIELD_GROUPING_TYPES, isFieldGroupingType } from "shared/dist/utils/fieldFilter";

export const GROUPING_TYPES = SharedGROUPING_TYPES;
export const GROUPING_SCOPES = SharedGROUPING_SCOPES;
export const GROUPING_STATUSES = SharedGROUPING_STATUSES;
export const CRITERION_CATEGORIES = SharedCRITERION_CATEGORIES;

export default interface Grouping extends SharedGrouping {}
